import styled from "styled-components";
import { Assets } from "../styles/assets";

export const ModalHeader = styled.div`
  width: 100%;  
  height: auto;
  display: flex;
  justify-content: flex-end;
  padding: 16px;  
`;

export const CloseButtonFloatContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-end;  
  position: absolute;
  background: transparent;  
  margin: 0;    
  box-sizing: border-box;   
  right: 0;
  z-index: 1000;
  
  margin-top:-10px;
`;


export const ModalContent = styled.div`
  width: 100%;
  height: auto;
  padding:0;
  margin:0;    
  color: #fff;
  border: 1px solid ${Assets.secondaryColor};
  border-radius: 24px;
  padding: 20px;
  box-sizing: border-box;
`;

